import { createSlice } from '@reduxjs/toolkit';
import {
    meteorologicoNodo,
} from '../actions/meteorologicoNodo';


export const SensoresReducerNodo = createSlice({
    name: 'meteorologicoNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(meteorologicoNodo.pending, (state) => { state.loading = true })
            .addCase(meteorologicoNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(meteorologicoNodo.rejected, (state) => { state.loading = false })
    }
})


export default SensoresReducerNodo.reducer;